module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_d/hero-916a01184857c6352c394acc8fc23502.jpg";